// Валюты ученических платежей (не путать с валютой SaaS-тарифов — Stars/USD).
// Выбор делается один раз на странице Аккаунт и применяется ко всем курсам
// и платежам. Хранится в профиле пользователя (user.currency).

export const CURRENCIES: { code: string; symbol: string; label: string }[] = [
  { code: 'KZT', symbol: '₸', label: 'Тенге (₸)' },
  { code: 'RUB', symbol: '₽', label: 'Рубли (₽)' },
  { code: 'USD', symbol: '$', label: 'Доллары ($)' },
  { code: 'EUR', symbol: '€', label: 'Евро (€)' },
];

export const DEFAULT_CURRENCY = 'KZT';

export function currencySymbol(code?: string | null): string {
  const c = (code || '').toUpperCase();
  return CURRENCIES.find(x => x.code === c)?.symbol || '₸';
}
